import type { CSSProperties } from "react";
import { spaceHomeMembershipRenewButtonCssVars } from "./SpaceHomeMembershipRenewButtonConfig";

/** 空间首页权益卡片：已开通标签（Web） */
export interface SpaceHomeMembershipActiveTagConfig {
  /** 标签宽度（px，对应 CSS min-width） */
  width: number;
  /** 标签高度（px） */
  height: number;
  /** 文案字号（px） */
  fontSize: number;
  /** 圆角（px） */
  borderRadius: number;
}

export const SPACE_HOME_MEMBERSHIP_ACTIVE_TAG = {
  width: 58,
  height: 22,
  fontSize: 12,
  borderRadius: 6,
} as const satisfies SpaceHomeMembershipActiveTagConfig;

export function spaceHomeMembershipActiveTagCssVars(
  config: SpaceHomeMembershipActiveTagConfig = SPACE_HOME_MEMBERSHIP_ACTIVE_TAG
): CSSProperties {
  return {
    ["--lf-space-membership-active-tag-width" as string]: `${config.width}px`,
    ["--lf-space-membership-active-tag-height" as string]: `${config.height}px`,
    ["--lf-space-membership-active-tag-font-size" as string]: `${config.fontSize}px`,
    ["--lf-space-membership-active-tag-border-radius" as string]: `${config.borderRadius}px`,
  };
}

/** 权益订阅区块：续订按钮 + 已开通标签等 CSS 变量 */
export function spaceHomeMembershipSubscribeSectionCssVars(): CSSProperties {
  return {
    ...spaceHomeMembershipRenewButtonCssVars(),
    ...spaceHomeMembershipActiveTagCssVars(),
  };
}
